import { useMemo, useState } from "react";

type Props = {
	label: string;
	defaultValue?: boolean;
	value?: boolean;
	disabled?: boolean;
	loading?: boolean;
	onChange?: (value: boolean) => void;
};

export const SettingsToggleItem: React.FC<Props> = ({
	label,
	defaultValue = false,
	value,
	disabled = false,
	loading = false,
	onChange,
}) => {
	const [uncontrolled, setUncontrolled] = useState(defaultValue);
	const isEnabled = useMemo(
		() => (typeof value === "boolean" ? value : uncontrolled),
		[value, uncontrolled],
	);

	const handleToggle = () => {
		if (disabled || loading) return;
		const newValue = !isEnabled;
		if (typeof value === "boolean") {
			onChange?.(newValue);
		} else {
			setUncontrolled(newValue);
			onChange?.(newValue);
		}
	};

	return (
		<div className="flex items-center justify-between px-3 py-2 hover:bg-blue-50 rounded-md">
			<span className="text-sm text-gray-700">{label}</span>
			<button
				onClick={handleToggle}
				data-enabled={isEnabled}
				disabled={disabled || loading}
				className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors bg-gray-300 data-[enabled=true]:bg-gpa-blue-500 disabled:opacity-60 disabled:cursor-not-allowed"
				role="switch"
				aria-checked={isEnabled}
			>
				<span
					data-enabled={isEnabled}
					className="inline-block h-4 w-4 transform rounded-full bg-white transition-transform translate-x-1 data-[enabled=true]:translate-x-6"
				/>
				{loading && (
					<span className="absolute -left-6 select-none text-xs text-gray-500">
						...
					</span>
				)}
			</button>
		</div>
	);
};
